/**
 * Permissions that only one system role carries, keyed by permission code.
 *
 * Another system role never holds them: the API refuses to write one there
 * and startup reconciliation strips it. A custom role (`isSystem: false`)
 * may carry them, and the role editor shows the checkbox disabled on every
 * other system role.
 */
export const CATALOG_ONLY_PERMISSIONS = {
    "cabinet:access": "CABINET_COMPTABLE",
};
/**
 * The catalogue-only permissions among `permissions` that the system role
 * `roleCode` may not hold.
 */
export function catalogOnlyPermissionsRefused(roleCode, permissions) {
    return permissions.filter((permission) => {
        const carrier = CATALOG_ONLY_PERMISSIONS[permission];
        return carrier !== undefined && carrier !== roleCode;
    });
}
//# sourceMappingURL=catalog-only.js.map